import { render, staticRenderFns } from "./Finalizacao.vue?vue&type=template&id=c5a52caa&scoped=true"
import script from "./Finalizacao.vue?vue&type=script&lang=js"
export * from "./Finalizacao.vue?vue&type=script&lang=js"
import style0 from "./Finalizacao.vue?vue&type=style&index=0&id=c5a52caa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a52caa",
  null
  
)

export default component.exports